import {
  CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN,
  SELECTOR_DROPDOWN_OPTION_ITEM,
  SELECTOR_DROPDOWN_OPTION_LIST,
  SELECTOR_DROPDOWN_SELECTED_OPTION,
} from '../constants';

/**
 * @type {import('../index.d').enhanceAccessibility}
 */
export function enhanceAccessibility(popup, closeButton, notifyButton, dropdownElement) {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      popup.setAttribute('aria-hidden', 'true');
      notifyButton.focus();
    }
  });

  popup.addEventListener('focusout', (event) => {
    if (!popup.contains(event.relatedTarget)) {
      closeButton.focus();
    }
  });

  if (dropdownElement) {
    const options = dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_OPTION_ITEM);
    dropdownElement.addEventListener('keydown', (event) => {
      const isExpanded = dropdownElement.getAttribute('aria-expanded') === 'true';
      const optionList = dropdownElement.querySelector(SELECTOR_DROPDOWN_OPTION_LIST);

      switch (event.key) {
        case 'Enter':
        case ' ': {
          event.preventDefault();
          if (!isExpanded) {
            dropdownElement.setAttribute('aria-expanded', 'true');
            optionList.classList.add(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN);
          } else {
            const focusedOption = document.activeElement;
            if (focusedOption?.classList.contains('boost-sd__bis-dropdown-option-item')) {
              focusedOption.click();
            }
          }
          break;
        }

        case 'ArrowDown':
        case 'ArrowUp': {
          event.preventDefault();
          const currentIndex = Array.from(options).indexOf(document.activeElement);
          const nextIndex =
            (currentIndex + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options[nextIndex]?.focus();
          break;
        }

        case 'Escape': {
          dropdownElement.setAttribute('aria-expanded', 'false');
          optionList.classList.remove(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN);
          dropdownElement.querySelector(SELECTOR_DROPDOWN_SELECTED_OPTION)?.focus();
          break;
        }
      }
    });
  }
}
